


function csvJSON(csv) {
    const lines = csv.split('\n')
    const result = []
    const headers = lines[0].split(',')
  
    for (let i = 1; i < lines.length; i++) {        
        if (!lines[i])
            continue
        const obj = {}
        const currentline = lines[i].split(',')
  
        for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j]
        }
        result.push(obj)
    }
    return result
  }


const returnSentenceCase=(str)=>{
    if(str){
      
        return str.split('').map((a)=>{return a.toUpperCase()==a?'-'+a:a}).join('').replace(/-/g,' ').split(' ').map((item)=>{let arr = item.split(''); arr[0] = arr[0].toUpperCase(); return arr.join(''); } ).join(' ');
    }
}

const __debounce=(cb, delay)=>{
    let timeoutID;
    return function(...args){
      if(timeoutID){
        clearTimeout(timeoutID)
      }
      timeoutID = setTimeout(() => {
        cb(...args)
      }, delay);
    }
}

const calculateAgeFun=(val, age)=>{

}

const returnDateWithFormat=(date,type)=>{
 
}


export { calculateAgeFun, returnDateWithFormat, returnSentenceCase, csvJSON, __debounce }

